import { css } from 'linaria';

export const headerSection = css`
  position: relative;
  width: 100%;
  margin-bottom: 70px;

  @media (--to-desktop) {
    margin-bottom: 46px;
  }

  @media (--only-mobile) {
    margin-bottom: 60px;
  }
`;

export const headerTitle = css`
  && {
    margin-bottom: 16px;
    text-align: center;

    @media (--only-mobile) {
      text-align: left;
    }
  }
`;

export const headerSubTitle = css`
  && {
    text-align: center;

    @media (--only-mobile) {
      text-align: left;
    }
  }
`;

export const headerSwiperSlide = css`
  && {
    width: 180px;
    height: 240px;
    margin-right: 20px;

    &:first-of-type {
      width: 380px;

      img {
        width: 220px;
        height: 240px;
      }
    }

    @media (--only-desktop) {
      width: 220px;

      &:first-of-type {
        width: 460px;
      }
    }

    @media (--only-tablet) {
      width: 156px;
      margin-right: 12px;

      &:first-of-type {
        width: 320px;

        img {
          width: 162px;
          height: 177px;
        }
      }
    }

    @media (--only-mobile) {
      width: 156px;
      margin-right: 12px;

      &:first-of-type {
        width: 156px;

        img {
          width: 107px;
          height: 107px;
        }
      }
    }
  }
`;

export const firstSwiperSlide = css`
  @media (--only-mobile) {
    display: none;
  }
`;

export const firstBannerTitle = css`
  && {
    max-width: 152px;
    margin-bottom: 4px;
  }
`;

export const firstBannerDescription = css`
  && {
    max-width: 152px;
    color: var(--text-secondary);
  }
`;

export const firstBannerButton = css`
  position: absolute;
  left: 24px;
  bottom: 24px;
`;

export const headerSwiperLink = css`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 24px;
  background-color: var(--background-secondary);
  border-radius: 4px;

  &:hover {
    background-color: var(--control-minor);
  }
`;

export const mobileFirstBanner = css`
  && {
    @media (--from-tablet) {
      display: none;
    }

    @media (--only-mobile) {
      width: 100%;
      height: 240px;
      margin-bottom: 32px;

      img {
        width: 122px;
        height: 133px;
      }
    }
  }
`;

export const swiperImage = css`
  && {
    width: 118px;
    height: 118px;

    @media (--to-desktop) {
      width: 107px;
      height: 107px;
    }
  }
`;
